// extracted by mini-css-extract-plugin
module.exports = {"header_container":"FJStockVideoHeaderView_header_container__2AzQH","cursor":"FJStockVideoHeaderView_cursor__3Z2fW"};